import { logNotification } from './OTelNotifications';
import { TelemetryProperties, LogLevel, Category } from './DataModels';

export namespace TenantTokenManager {
  const NAMESPACE_SEPARATOR = '.';

  // The tenant tokens should always be sorted in order by decreasing length, so that when iterating
  // through the list we always get the most specific token first
  let tenantTokens: { namespace: string; telemetryProperties: TelemetryProperties }[] = [];
  let tenantTokenEventCache: { [eventName: string]: TelemetryProperties } = {};

  export function setTenantTokens(namespace: string, telemetryProperties: TelemetryProperties) {
    let parts = namespace.split(NAMESPACE_SEPARATOR);

    // Ensure that the provided namespace is valid
    if (parts.length < 2 || parts[0] !== 'Office' || namespace[namespace.length - 1] === NAMESPACE_SEPARATOR) {
      logNotification(LogLevel.Error, Category.Core, () => {
        return `Invalid namespace: ${namespace}`;
      });
      return;
    }

    tenantTokens.push({ namespace, telemetryProperties });
    // Sort the namespaces in decreasing order by length
    tenantTokens.sort((a, b) => {
      return b.namespace.length - a.namespace.length;
    });
    tenantTokenEventCache = {};
  }

  export function getTenantTokens(eventName: string) {
    if (eventName in tenantTokenEventCache) {
      return tenantTokenEventCache[eventName];
    }
    for (let i = 0; i < tenantTokens.length; i++) {
      const namespace = tenantTokens[i].namespace;
      if (eventName.substring(0, namespace.length + 1) === namespace + NAMESPACE_SEPARATOR) {
        tenantTokenEventCache[eventName] = tenantTokens[i].telemetryProperties;
        return tenantTokenEventCache[eventName];
      }
    }
    return undefined;
  }

  export function clear() {
    tenantTokens = [];
    tenantTokenEventCache = {};
  }
}
